import { dateFormat } from '@/utils/api';

export const useAppointmentDate = () => {
	const formatAppointmentText = (date, startDate, endDate, format = 'yyyy/MM/dd') => {
		const dateObj = new Date(Number(date));

		// 只有 date
		if (!startDate) {
			return dateFormat(dateObj, format);
		}
		// 有 startDate 无 endDate
		else if (startDate && !endDate) {
			const startDateObj = new Date(Number(startDate));
			return dateFormat(startDateObj, `${format} HH:mm`);
		}
		// 有 startDate 和 endDate
		else {
			const startDateObj = new Date(Number(startDate));
			const endDateObj = new Date(Number(endDate));
			return `${dateFormat(startDateObj, `${format} HH:mm`)} - ${dateFormat(endDateObj, 'HH:mm')}`;
		}
	};

	return {
		formatAppointmentText
	};
};
